// This file is AUTOGENERATED, do not edit it manually!!!

export const imageAnnotations = {
    apply: 'Aplicar',
    back: 'Volver a mensajes',
    cancel: 'Cancelar',
    comment: 'Comentario',
    commented_on_image: 'comentado en la imagen',
    comments: 'Comentarios',
    delete: 'Eliminar',
    delete_comment: 'Eliminar este comentario?',
    deleted_image: 'La imagen ha sido eliminada',
    download: 'Descargar imagen',
    edit: 'Editar',
    no_comment: 'No hay comentarios para mostrar',
    write_comment: 'Escribe tu comentario',
};
